/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react'
import { AuctionResponse } from '../../../types'

interface Props {
    item?: AuctionResponse
}

const TabContent1 = ({ item }: Props) => {
    const [seeMore, setSeeMore] = useState(false);

    // useEffect(() => {
    //     console.log(item)
    // }, [item])

    return (
        <div>
            <div style={{ maxHeight: seeMore ? '100%' : '545px', overflow: 'hidden' }}>
                <h3 style={{ fontWeight: 'bold' }}>{item?.productName || ""}</h3>
                <p style={{ marginTop: 30 }}>
                    <span style={{ fontWeight: 700, textDecoration: 'underline', marginRight: 5 }}>Nơi có tài sản:</span>{item?.addressHasProperty || ""}
                </p>
                <p>
                    <span style={{ fontWeight: 700, textDecoration: 'underline' }}>Mô tả:</span>
                </p>
                <p style={{ marginTop: 10 }}>{item?.description || ""}</p>

            </div>

            {!seeMore && <div className="see-more" onClick={() => setSeeMore(true)}>
                Xem thêm
            </div>
            }
        </div>
    )
}

export default TabContent1